<!--
 * @Author: qoder
 * @Description: 添加维修记录
-->
<template>
  <ykc-form :model="ruleForm" :rules="rules" ref="ruleForm" class="form-container">
    <ykc-form-item label="维修内容" prop="content">
      <ykc-input
        type="textarea"
        :rows="4"
        maxlength="500"
        placeholder="请输入维修内容"
        v-model="ruleForm.content"></ykc-input>
    </ykc-form-item>
    <ykc-form-item label="当日是否完成">
      <ykc-radio
        :data="[
          { id: 1, name: '是' },
          { id: 2, name: '否' },
        ]"
        v-model="ruleForm.canCompleteToday"></ykc-radio>
    </ykc-form-item>
    <ykc-form-item
      label="下次计划维修日期"
      prop="nextRepairDate"
      v-if="ruleForm.canCompleteToday === 2">
      <ykc-date-picker
        type="date"
        placeholder="请选择下次计划维修日期"
        v-model="ruleForm.nextRepairDate"></ykc-date-picker>
    </ykc-form-item>
    <ykc-form-item
      label="下次维修准备事项"
      prop="preparation"
      v-if="ruleForm.canCompleteToday === 2">
      <ykc-input
        type="textarea"
        :rows="3"
        maxlength="300"
        placeholder="请输入下次维修准备事项"
        v-model="ruleForm.preparation"></ykc-input>
    </ykc-form-item>
    <ykc-form-item label="维修照片" prop="photoUrls">
      <ykc-upload
        :fileList="fileList"
        :limit="10"
        accept=".jpg,.jpeg,.png"
        @handleChange="handleUpload"
        @handleRemove="handleRemove"></ykc-upload>
    </ykc-form-item>
  </ykc-form>
</template>

<script>
  import { repairOrderApi, uploadUtils } from '@/service/apis';

  export default {
    name: 'AddRecord',
    props: {
      orderInfo: {
        type: Object,
        default: null,
      },
      batchOrderIds: {
        type: Array,
        default: null,
      },
    },
    data() {
      return {
        ruleForm: {
          content: '',
          canCompleteToday: 1,
          nextRepairDate: '',
          preparation: '',
          photoUrls: [],
        },
        fileList: [],
        rules: {
          content: [{ required: true, message: '请输入维修内容', trigger: 'blur' }],
          photoUrls: [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (this.ruleForm.photoUrls.length === 0) {
                  callback(new Error('请上传维修照片'));
                } else {
                  callback();
                }
              },
              trigger: 'change',
            },
          ],
          nextRepairDate: [
            { required: true, message: '请选择下次计划维修日期', trigger: 'change' },
          ],
          preparation: [{ required: true, message: '请输入下次维修准备事项', trigger: 'blur' }],
        },
      };
    },
    methods: {
      submit() {
        return new Promise(resolve => {
          const isBatch = this.batchOrderIds && this.batchOrderIds.length > 0;
          if (!isBatch && !this.orderInfo?.id) {
            this.$message.error('工单信息缺失');
            resolve(false);
            return;
          }
          this.$refs.ruleForm.validate(async valid => {
            if (!valid) {
              resolve(false);
              return;
            }
            try {
              const params = {
                content: this.ruleForm.content,
                canCompleteToday: this.ruleForm.canCompleteToday,
                preparation: this.ruleForm.preparation,
                operatorId: localStorage.userId,
                operatorName: localStorage.accountName,
                photoUrls: this.ruleForm.photoUrls,
              };
              if (this.ruleForm.canCompleteToday === 2 && this.ruleForm.nextRepairDate) {
                const date = new Date(this.ruleForm.nextRepairDate);
                params.nextRepairDate = this.formatDate(date);
              }
              if (isBatch) {
                params.orderIds = this.batchOrderIds;
                await repairOrderApi.batchAddRecord(params);
                this.$message.success('批量添加维修记录成功');
              } else {
                params.orderId = this.orderInfo.id;
                await repairOrderApi.addRecord(params);
                this.$message.success('添加成功');
              }
              this.$emit('success');
              resolve(true);
            } catch (error) {
              console.error('提交失败', error);
              this.$message.error(error?.message || '提交失败');
              resolve(false);
            }
          });
        });
      },
      // 上传图片：先上传到OSS获取真实URL，再保存到表单
      handleUpload(file, fileList, isCheck) {
        if (!isCheck) return;
        const formData = new FormData();
        formData.append('file', file.raw);
        formData.append('bizName', 'poly/repair');
        uploadUtils
          .uploadImg(formData)
          .then(res => {
            // res 为后端返回的 OSS 图片地址
            const ossUrl = res;
            // 更新 fileList 中对应文件的 url 为真实 OSS 地址
            const target = this.fileList.find(f => f.uid === file.uid);
            if (target) {
              target.url = ossUrl;
              target.ossUrl = ossUrl;
            } else {
              this.fileList.push({
                ...file,
                url: ossUrl,
                ossUrl,
              });
            }
            // 同步到 ruleForm.photoUrls
            this.ruleForm.photoUrls = this.fileList.map(f => f.ossUrl || f.url);
            // 上传成功后主动校验该字段，清除可能残留的错误提示
            this.$refs.ruleForm?.validateField('photoUrls');
          })
          .catch(err => {
            console.error('上传图片失败', err);
            this.$message.error('上传图片失败，请重试');
            // 上传失败则移除该文件
            this.fileList = this.fileList.filter(f => f.uid !== file.uid);
            this.ruleForm.photoUrls = this.fileList.map(f => f.ossUrl || f.url);
          });
      },
      handleRemove(file) {
        this.fileList = this.fileList.filter(f => f.uid !== file.uid);
        this.ruleForm.photoUrls = this.fileList.map(f => f.ossUrl || f.url);
      },
      formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .form-container {
    padding: 20px;
  }
</style>
